import defaultTranslation from "../../i18n/translations.json";

export type TranslationKeyType = keyof typeof defaultTranslation;

export const supportedLocales = ["en", "da", "es", "de", "sv"];
